import React from 'react';
import { Stepper, Container, Box } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

/**
 * ProgressStepper Component
 * Visual progress indicator for the multi-step registration form
 */
const ProgressStepper = ({ currentStep, totalSteps = 4, isComplete = false }) => {
  // If registration is complete, show all steps as done
  const activeStep = isComplete ? totalSteps : currentStep - 1;

  // Below 768px, hide the label + description so all 4 steps stay on one line
  const isMobile = useMediaQuery('(max-width: 48em)');
  const stepText = (label, description) => isMobile ? {} : { label, description };

  return (
    <Box
      style={{
        background: 'var(--warm-white)',
        borderBottom: '1px solid var(--light-gray)',
        padding: 'clamp(1rem, 3vw, 2rem) 0',
        marginBottom: 'clamp(0.5rem, 2vw, 2rem)'
      }}
    >
      <Container size="lg">
        <Stepper
          active={activeStep}
          size="sm"
          color="var(--primary-gold)"
          completedIcon={
            <span style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: 'var(--primary-gold)'
            }}>✓</span>
          }
          styles={(theme) => ({
            step: {
              transition: 'all 0.3s ease'
            },
            stepIcon: {
              backgroundColor: 'white',
              border: '2px solid var(--light-gray)',
              color: 'var(--soft-gray)',
              '&[data-completed]': {
                backgroundColor: 'white',
                borderColor: 'var(--primary-gold)',
                color: 'var(--primary-gold)',
                fontWeight: 'bold'
              },
              '&[data-progress]': {
                borderColor: 'var(--primary-gold)',
                borderWidth: '3px'
              }
            },
            stepLabel: {
              fontWeight: 500,
              fontSize: '0.9rem',
              color: 'var(--charcoal)'
            },
            stepDescription: {
              fontSize: '0.8rem',
              color: 'var(--soft-gray)'
            },
            separator: {
              backgroundColor: 'var(--light-gray)',
              height: '2px',
              '&[data-active]': {
                backgroundColor: 'var(--primary-gold)'
              }
            }
          })}
        >
          <Stepper.Step {...stepText('Information', 'Personal details')} />
          <Stepper.Step {...stepText('Consent', 'Agreements & waivers')} />
          <Stepper.Step {...stepText('Entries', 'Solos & ensembles')} />
          <Stepper.Step {...stepText('Payment', 'Complete registration')} />
        </Stepper>
      </Container>
    </Box>
  );
};

export default ProgressStepper;
